import JSZip from 'jszip'
import { parseTam } from './parser'
import type { JsZipLike, ParsedWell } from './types'

export async function parseTamFile(file: File): Promise<ParsedWell[]> {
  const buf = await file.arrayBuffer()
  const zip = await JSZip.loadAsync(buf)
  return parseTam(zip as unknown as JsZipLike)
}

/** Fecha del estudio: la más reciente entre todas las pruebas del archivo (calendario local). */
export function inferTamStudyDate(wells: ParsedWell[]): string | null {
  let latest: Date | null = null
  for (const w of wells) {
    for (const t of w.tests) {
      if (t.date && (!latest || t.date.getTime() > latest.getTime())) {
        latest = t.date
      }
    }
  }
  if (!latest) return null
  const y = latest.getFullYear()
  const m = String(latest.getMonth() + 1).padStart(2, '0')
  const d = String(latest.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

export function tamWellNames(wells: ParsedWell[]): string[] {
  return wells.map((w) => w.name).filter(Boolean)
}
